/* eslint-disable max-lines */
import { AfterViewChecked, Component, OnInit, Type, ViewChild } from '@angular/core';
// import { AdvisoryToolActivateClientDialog } from '@app/advisory-tool/components/advisory-tool-activate-client/advisory-tool-activate-client.dialog';
import { isSweden } from '@app/core/entity/locale';
import { AllInclusiveService } from '@app/core/services/all-inclusive.service';
import { AuthSelectors } from '@app/core/state/auth/auth.selectors';
import { ClientSelectors } from '@app/core/state/clients/clients.selectors';
import { ClientTypesSelectors } from '@app/core/state/clientTypes/clientTypes.selectors';
import { CreditInformationActions } from '@app/core/state/credit-information/credit-information.actions';
import { CreditInformationSelectors } from '@app/core/state/credit-information/credit-information.selectors';
import { FirmSelectors } from '@app/core/state/firm/firm.selectors';
import { TeamsActions } from '@app/core/state/teams/teams.actions';
import { TeamsSelectors } from '@app/core/state/teams/teams.selectors';
import {
  getAccountPeriod,
  toClientTypeFromCreditInformationTransformer,
} from '@app/core/state/transformers/credit-information.transformers';
import { toClientTransformer, toClientTypeTransformer } from '@app/core/state/transformers/transformers';
import { CreditInformationType } from '@app/core/state/types/credit-information.types';
import { CreateCloudDbWizardService } from '@app/shared/components/cloud-db-export-wizard/create-clouddb-wizard.service';
import { getActivateOrDeactivateSustainabilityReportingInfo } from '@app/shared/misc/getActivateOrDeactivateSustainabilityReportingInfo';
import { openDialog, openTranslatableDialog } from '@app/shared/misc/openDialog';
import { isValidCorporateIdentity } from '@bl/functions';
import { TooltipOptions } from 'primeng/api';
import { CheckboxChangeEvent } from 'primeng/checkbox';
import { DialogService, DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { BehaviorSubject, EMPTY, Observable, of } from 'rxjs';
import { delay, filter, first, map, mergeMap, switchMap, take } from 'rxjs/operators';
import { AnalyticsAction } from 'src/app/core/entity/analytics/analytics-actions';
import { Client } from 'src/app/core/entity/client';
import { FinancialYear } from 'src/app/core/entity/financialyear';
import { Role, User } from 'src/app/core/entity/user';
import { UserAuthFacade } from 'src/app/core/facades/user-auth.facade';
import { getTranslationProvider } from 'src/app/core/i18n/getTranslationProvider';
import { TranslatableFormDialogBaseComponent } from 'src/app/core/i18n/translatable-form-dialog-base.component';
import { TranslatableComponent } from 'src/app/core/i18n/TranslatableComponent';
import { ClientService } from 'src/app/core/services/clients.service';
import { CloudCompanyService } from 'src/app/core/services/cloud-company.service';
import { UserService } from 'src/app/core/services/user.service';
import { AnalyticActions } from 'src/app/core/state/analytics/analytics.actions';
import { ClientActions } from 'src/app/core/state/clients/clients.actions';
import { ToastActions } from 'src/app/core/state/toast/toast.actions';
import { toClientTypeFromKvkInformationTransformer } from 'src/app/core/state/transformers/kvk-information.transformers';
import { ClientType, ClientTypeType, TeamType, UserType } from 'src/app/core/state/types';
import { isKvkInformationType, KvkInformationType } from 'src/app/core/state/types/kvk-information.types';
import { UserSelectors } from 'src/app/core/state/users/users.selectors';
import { DirtyItem } from 'src/app/shared/misc/dirty.item';
import { CorporateIdentityInputComponent } from '../corporate-identity-input/corporate-identity-input.component';
import { DialogResult } from '../form-dialog-base/form-dialog-base.component';
import { MissingCloudApiKeyDialog } from '../missing-cloud-api-key/missing-cloud-api-key.dialog';
import { TabsComponent } from '../tabs/tabs.component';
import { ActivateSustainabilityReportingDialog } from './components/activate-sustainability-reporting-dialog/activate-sustainability-reporting-dialog';
import { AskForCollaborationPackagesOnNewClientDialog } from './dialogs/ask-for-collaboration-packages-on-new-client.dialog';
import { ChangeResponsibleWarningDialog } from './dialogs/change-responsible-warning.dialog';
import { CorporateIdentityExistsDialog } from './dialogs/corporate-identify-exists.dialog';
import { CreateClouddbConfirmationDialog } from './dialogs/create-clouddb-confirmation.dialog';
import { CreditInformationUpdateDialog } from './dialogs/credit-information-update.dialog';
import { KvkInformationUpdateDialog } from './dialogs/kvk-information-update.dialog';
// import { GenerateAdvisoryReportDialog } from './dialogs/generate-advisory-report.dialog';
import { SaveDirtyChangesDialog } from './dialogs/save-dirty-changes.dialog';
import { NewClientDialogConfig, NewClientDialogResult, NewClientDialogTranslations } from './types';

@Component({
  selector: 'app-new-client-dialog',
  templateUrl: './new.client.dialog.html',
  providers: [DialogService, CreateCloudDbWizardService, getTranslationProvider('newClientDialog')],
})
export class NewClientDialog
  extends TranslatableComponent<NewClientDialogTranslations>
  implements OnInit, AfterViewChecked
{
  @ViewChild('tabs', { static: true }) tabs: TabsComponent;
  @ViewChild('corporateIdentityInput', { static: true }) corporateIdentityInput: CorporateIdentityInputComponent;

  public availableUsers$: Observable<UserType[]>;
  public selectedType: string;
  public displayDialog = false;
  public displayInviteBlapp = false;
  public hidePleaseWait = true;
  public documentTabActive = false;
  public cloudServiceTabActive = false;
  public lundifyTabActive = false;
  public amlTabActive = false;
  public hasPermissionToChange$: Observable<{ value: boolean }>;
  public clientTypes$: Observable<ClientTypeType[]>;
  public selectedTeamIds: number[];
  public canActivateSustainabilityReportingDialog = false;
  public createCloudDbTooltipOptions: TooltipOptions = {
    tooltipPosition: 'top',
    tooltipStyleClass: 'tooltip-extended-width',
  };
  public createCloudDbButtonText$: Observable<string>;
  public i18n: NewClientDialogTranslations;

  private listOfDirtyComponents: DirtyItem[] = [];
  private clientTypesBS: BehaviorSubject<ClientTypeType[]>;
  private teamIds: number[];
  private showMissingCollaborationInfoDialog = false;

  _model: Client = new Client('');
  submitted = false;
  creditInformationDefaultFinancialYears: FinancialYear;
  rootTeam: TeamType;
  teams: { id: number; name: string }[];

  // eslint-disable-next-line max-lines-per-function
  constructor(
    private clientService: ClientService,
    private cloudCompanyService: CloudCompanyService,
    private userAuthFacade: UserAuthFacade,
    private userService: UserService,
    private ref: DynamicDialogRef,
    public config: DynamicDialogConfig<NewClientDialogConfig>,
    private dialogService: DialogService,
    private allInclusiveService: AllInclusiveService,
    private createCloudDbWizardService: CreateCloudDbWizardService,
  ) {
    super();
    this.i18n = {} as NewClientDialogTranslations;

    this.availableUsers$ = this.store.select(UserSelectors.activeUsersWithChoose);
    this.hasPermissionToChange$ = this.userAuthFacade.isAdminOrResponsibleForClient$.pipe(map((value) => ({ value })));
    this.clientTypesBS = new BehaviorSubject([]);
    this.store
      .select(ClientTypesSelectors.all)
      .pipe(
        map((clientTypes) => {
          const description = this.translate('constants.SELECT_WITH_HYPHENS', { useComponentScope: false }) as string;
          return [{ name: '', description }].concat(clientTypes);
        }),
        this.takeUntilDestroyed(),
      )
      .subscribe(this.clientTypesBS);
    this.clientTypes$ = this.clientTypesBS.asObservable();
    this.store
      .select(this.selector)
      .pipe(first())
      .subscribe(({ ids }) => {
        this.teamIds = ids;
      });
    this.store
      .select(TeamsSelectors.selectRootTeam)
      .pipe(
        filter((rootTeam) => Boolean(rootTeam)),
        first(),
      )
      .subscribe((team) => {
        this.rootTeam = team;
      });

    this.teams = [];
    this.reactToCreditInformationUpdate();
    this.createCloudDbButtonText$ = this.createCloudDbButtonTextObservable();
  }

  get isNewClient() {
    return !this._model.id || this._model.id === -1;
  }

  get isPersonCompanyType() {
    return this._model.type && this._model.type.name === 'PERSON';
  }

  get isArchived() {
    return this._model.archived;
  }

  get isOnlyWorkflowFirm() {
    return !this.allInclusiveService.isLoggedInWithAnyAllInclusiveService;
  }

  get subscriptionTabTooltip() {
    type TooltipHandler = () => string | null;
    const handlers: TooltipHandler[] = [
      () => (this.isOnlyWorkflowFirm ? this.i18n.subscriptionTabTooltipOnlyWorkflowFirm : null),
      () => (this.isNewClient || !this._model.cloudApiKey ? this.i18n.subscriptionTabTooltipNoPublicKey : null),
      () => (this.isPersonCompanyType ? this.i18n.subscriptionTabTooltipPersonType : null),
    ];

    for (const handler of handlers) {
      const result = handler();
      if (result !== null) {
        return result;
      }
    }

    return null;
  }

  get createCloudDbTooltip() {
    if (this.allInclusiveService.isLoggedInWithBLTAService) {
      return {
        title: this.i18n.newCollaborationPackage,
        description: this.i18n.newCollaborationPackageDescriptionText,
      };
    }
    return null;
  }

  get isPossibleToCreateCloudDb() {
    const isClientPersonType = this._model && this._model.type && this._model.type.name === 'PERSON';
    const isFormValuesValid =
      this._model.corporateIdentity && !this._model.archived && this._model.name && this.selectedType;
    const isLoggedInWithAllInclusiveService = this.allInclusiveService.isLoggedInWithAnyAllInclusiveService;

    return (
      !this.isNewClient &&
      !this._model.cloudApiKey &&
      !isClientPersonType &&
      isFormValuesValid &&
      isLoggedInWithAllInclusiveService &&
      this.hidePleaseWait
    );
  }

  // get isPossibleToActivateAdvisoryTool() {
  //   return !this.isNewClient && !this._model.advisoryTool && this.hidePleaseWait && !this._model.archived;
  // }

  get isPossibleToUpdateCloudCompany() {
    return !this._model.archived && !this.isNewClient && this._model.cloudApiKey && this._model.corporateIdentity;
  }

  get activateOrDeactivateSustainabilityReportingInfo() {
    return getActivateOrDeactivateSustainabilityReportingInfo(
      this.store.select(AuthSelectors.selectAuthUser),
      this.toClientType(this._model),
      this.config.data.firm,
    );
  }

  protected override onTranslationsLoaded(): void {
    this.i18n = this.getTranslations();
  }

  toClientType(model: Client): ClientType {
    return toClientTypeTransformer.transform(model);
  }

  private setClient(model: Client, tabToOpen?: string) {
    this.showMissingCollaborationInfoDialog = false;
    if (!model.id || model.id === -1) {
      this.initNewClient();
      return;
    }

    this.initExistingClient(model, tabToOpen);
  }

  private initNewClient = () => {
    this._model = new Client('');
    this._model.userId = 0;
    this.tabs.selectFirst();
    this.userAuthFacade.updateAccessRightBasedOnResponsibleUserId(this._model.userId);
  };

  private initExistingClient = (client: Client, tabToOpen?: string) => {
    this._model = client;
    if (this._model.userId == null) {
      this._model.userId = 0;
    }
    this.selectedType = this._model.type.name;
    this.userAuthFacade.updateAccessRightBasedOnResponsibleUserId(this._model.userId);

    if (tabToOpen) {
      this.tabs.selectTabById(tabToOpen);
    }
  };

  override ngOnInit() {
    super.ngOnInit();
    this.setClient(this.config.data.client, this.config.data.tabToOpen);
  }

  ngAfterViewChecked(): void {
    this.corporateIdentityInput.focus();
  }

  closeDialog(client?: Client) {
    if (!this.hasDirtyItems()) {
      this.listOfDirtyComponents = [];
      this.hidePleaseWait = true;
      this.creditInformationDefaultFinancialYears = undefined;
      this.displayDialog = false;

      this.beforeCloseDialog().subscribe((result: { confirmed: boolean }) => {
        this.showMissingCollaborationInfoDialog = false;

        if (result?.confirmed) {
          this.onCreateCloudDbClick();
        }

        const closeResult: NewClientDialogResult = { client };
        this.ref.close(closeResult);
      });
    }
  }

  private beforeCloseDialog(): Observable<DialogResult> {
    if (
      this.showMissingCollaborationInfoDialog &&
      this.isPossibleToCreateCloudDb &&
      this.allInclusiveService.isLoggedInWithBLTAService
    ) {
      return openTranslatableDialog({
        deps: { dialogService: this.dialogService, translationService: this.translationService, store: this.store },
        componentType: AskForCollaborationPackagesOnNewClientDialog,
        data: {},
      }).pipe(first());
    }
    return of(null);
  }

  private setType() {
    this._model.type = this.clientTypesBS.value.find((t) => t.name === this.selectedType);
  }

  onSubmit() {
    this.submitted = true;
  }

  public addClient(callback?: () => void) {
    this.onPreClientSave();

    this.store
      .select(ClientSelectors.checkUniqueOrgNr(this._model.corporateIdentity))
      .pipe(
        filter((isUnique) => isUnique || !this.isNewClient),
        mergeMap(() => this.clientService.addClient(this._model, this.teamIds)),
        first(),
      )
      .subscribe({
        next: (client) => {
          this.showMissingCollaborationInfoDialog = this.isNewClient;
          this.onAfterClientSave(client, this.i18n.clientHasBeenSaved);
          if (callback) {
            callback();
          }
        },
        complete: () => {
          this.hidePleaseWait = true;
        },
      });

    this.store
      .select(ClientSelectors.checkUniqueOrgNr(this._model.corporateIdentity))
      .pipe(
        filter((isUnique) => !isUnique && this.isNewClient),
        first(),
        mergeMap(() => this.showCorporateIdentityExistsDialog()),
      )
      .subscribe({
        next: (client) => {
          this.showMissingCollaborationInfoDialog = this.isNewClient;
          this.onAfterClientSave(client, this.i18n.clientHasBeenSaved);
        },
        complete: () => {
          this.hidePleaseWait = true;
        },
      });
  }

  public saveClientAndUpdateCloud() {
    this.onPreClientSave();

    this.clientService
      .addClient(this._model, this.teamIds)
      .pipe(
        switchMap((client: Client) =>
          this.cloudCompanyService.updateCloudCompanyInformationByClientId(client.id).pipe(map(() => client)),
        ),
      )
      .subscribe({
        next: (client: Client) => {
          this.onAfterClientSave(client, this.i18n.clientHasBeenSavedAndUpdatedInCloud);
        },
        error: () => {
          this.hidePleaseWait = true;
        },
      });
  }

  private hasDirtyItems(): boolean {
    const isDirty = this.listOfDirtyComponents.some((item) => item.dirty);

    if (isDirty) {
      openTranslatableDialog({
        deps: { dialogService: this.dialogService, translationService: this.translationService, store: this.store },
        componentType: SaveDirtyChangesDialog,
        data: {},
      }).subscribe((result) => {
        this.saveDirtyBeforeClose(result?.confirmed);
      });
    }
    return isDirty;
  }

  saveDirtyBeforeClose(save: boolean) {
    if (!save) {
      this.listOfDirtyComponents = [];
      this.closeDialog();
      return;
    }

    this.addClient(() => {
      this.closeDialog();
    });
  }

  isDirty(dirty: DirtyItem) {
    if (!this.listOfDirtyComponents.filter((item) => item.component === dirty.component).length) {
      this.listOfDirtyComponents.push(dirty);
    }
    this.listOfDirtyComponents
      .filter((item) => item.component === dirty.component)
      .forEach((item) => {
        item.dirty = dirty.dirty;
      });
  }

  imDirty() {
    this.isDirty(new DirtyItem('BasicDetails', true));
  }

  handleReturnEvent(client: Client) {
    this.hidePleaseWait = true;
    this._model.id = client.id;
    this.config.data.newClientEmitter?.(client);
    if (this._model.userId == null) {
      this._model.userId = 0;
    }
  }

  harvestDetails(client: Client) {
    if (!client.saveFlag) {
      return;
    }

    if (client.saveFlag >= 0) {
      this._model.description = client.description;
      this._model.businessArea = client.businessArea;
      this._model.specialRules = client.specialRules;
      this._model.otherInfo = client.otherInfo;
      this._model.accountant = client.accountant;
      this._model.bank = client.bank;
      this._model.registrationDate = client.registrationDate;
    }

    if (client.saveFlag === 1 && this._model.name !== '') {
      this.addClient();
    } else if (client.saveFlag === -1) {
      this.closeDialog();
    }
  }

  callForUpdate(_event: boolean) {
    this.config.data.updateEmitter?.(true);
  }

  onFinancialYearUpdated(financialYears: FinancialYear[]) {
    this._model.financialYears = financialYears;
    this.config.data.updateEmitter?.(true);
  }

  // openActivateAdvisoryComponent() {
  //   openDialog(this.dialogService, AdvisoryToolActivateClientDialog, {
  //     client: toClientTypeTransformer.transform(this._model),
  //   }).subscribe((result) => {
  //     if (!result) {
  //       return;
  //     }

  //     const { client, openClientCard } = result;

  //     if (openClientCard) {
  //       this.openCloudServiceTab();
  //       return;
  //     }

  //     if (client) {
  //       this._model = toClientTransformer.transform(result.client);
  //     }
  //   });
  // }

  onClientUpdatedInCloudServiceTab(updatedClient: Client, saveClient = true) {
    this._model.cloudApiKey = updatedClient.cloudApiKey;

    if (saveClient) {
      this.addClient();
      return;
    }

    this._model = updatedClient;
    this.handleReturnEvent(updatedClient);
  }

  openCloudServiceTab() {
    // hide the dialog and change tab to Molntjänster. Maybe continue to build on this to automatically continue with the activation
    // after cloudDb has been added
    this.tabs.selectTabById('cloudServices');
  }

  getCreditInformation() {
    this.store.dispatch(CreditInformationActions.load({ corporateIdentity: this._model.corporateIdentity }));
  }

  showCreditInformationToUpdateDialog(creditInformation: CreditInformationType | KvkInformationType) {
    const clientFromCreditInfo = isKvkInformationType(creditInformation)
      ? toClientTypeFromKvkInformationTransformer.transform(creditInformation)
      : toClientTypeFromCreditInformationTransformer.transform(creditInformation);

    openTranslatableDialog({
      deps: { dialogService: this.dialogService, translationService: this.translationService, store: this.store },
      componentType: isKvkInformationType(creditInformation)
        ? (KvkInformationUpdateDialog as Type<TranslatableFormDialogBaseComponent>)
        : (CreditInformationUpdateDialog as Type<TranslatableFormDialogBaseComponent>),
      data: {
        client: {
          ...clientFromCreditInfo,
          corporateIdentity: this._model.corporateIdentity,
        },
      },
    })
      .pipe(filter((result: { client: Partial<ClientType> }) => Boolean(result?.client)))
      .subscribe(({ client }) => {
        this._model = Object.assign(this._model, client);
        this.imDirty();
      });
  }

  onCreateCloudDbClick() {
    const { email } = this._model;
    openTranslatableDialog({
      deps: { dialogService: this.dialogService, translationService: this.translationService, store: this.store },
      componentType: CreateClouddbConfirmationDialog,
      data: { email },
    }).subscribe((result) => {
      this.showMissingCollaborationInfoDialog = false;

      if (!result?.confirmed) {
        return;
      }

      // clients email not empty, continue with creating cloud db without updating email
      if (this._model.email) {
        this.confirmCreateCloudDbConfirmation();
        return;
      }

      // Update email on client before continuing
      this._model.email = result.email;
      this.addClient(() => this.confirmCreateCloudDbConfirmation());
    });
  }

  confirmCreateCloudDbConfirmation() {
    const client = { ...this._model };

    if (this.allInclusiveService.isLoggedInWithBLTAService) {
      this.showExportWizardForOnboarding(client);
      this.closeDialog();
      return;
    }

    this.showExportWizardForCloudDb(client);
  }

  trackEventWhenActive(active: boolean, tabName: string) {
    if (!active) {
      return;
    }
    this.store.dispatch(
      AnalyticActions.trackClientsEvent({
        action: AnalyticsAction.ClientTabs,
        name: `Opened ${tabName} tab`,
      }),
    );
  }

  private showExportWizardForOnboarding(client: Client): void {
    this.createCloudDbWizardService.runOnboardingWizard(client).subscribe();
  }

  private showExportWizardForCloudDb(client: Client): void {
    this.hidePleaseWait = false;

    this.createCloudDbWizardService.runCreateCloudDbWizard(client).subscribe({
      next: (cloudApiKey) => {
        this._model.cloudApiKey = cloudApiKey;
      },
      error: () => {
        this.hidePleaseWait = true;
      },
      complete: () => {
        this.hidePleaseWait = true;
      },
    });
  }

  onResponsibleUserChanged(responsibleUserId: number) {
    this.imDirty();

    if (responsibleUserId === 0) {
      return;
    }

    this.userService
      .getCurrentUser()
      .pipe(take(1))
      .subscribe((currentUser: User) => {
        if (currentUser.role === Role.FIRM_USER && currentUser.id !== responsibleUserId) {
          this.showWarningForChangingResponsibleUser();
        }
      });
  }

  onForeignCorporateIdentityChange({ checked }: CheckboxChangeEvent) {
    this._model.foreignCorporateIdentity = checked;
    this.imDirty();
  }

  onCorporateIdentyChange(corporateIdentity: string) {
    if (corporateIdentity !== '') {
      this.imDirty();
    }
  }

  public onTeamsChanged(teamIds: number[]) {
    this.teamIds = teamIds;
  }

  public OnTeamsInit() {
    if (!this.isNewClient) {
      this.updateTeams(this._model, this.rootTeam.id);
      return;
    }

    // new clients need to set their selected teams after the team selector has been initialized
    this.store
      .select(this.selector)
      .pipe(first(), delay(0)) // delay is needed to avoid ExpressionChangedAfterItHasBeenCheckedError
      .subscribe(({ ids }) => {
        this.selectedTeamIds = ids;
      });
  }

  public get selector() {
    return TeamsSelectors.selectNewClientTeamSelector;
  }

  public showActivateSustainabilityReportingDialog = () => {
    if (!this._model.cloudApiKey) {
      openDialog(this.dialogService, MissingCloudApiKeyDialog, {
        client: toClientTypeTransformer.transform(this._model),
        featureToActivate: 'hållbarhetsredovisning',
      })
        .pipe(filter((result) => Boolean(result?.client)))
        .subscribe(() => this.openCloudServiceTab());
      return;
    }

    openDialog(this.dialogService, ActivateSustainabilityReportingDialog, {
      client: toClientTypeTransformer.transform(this._model),
    })
      .pipe(filter((result) => Boolean(result)))
      .subscribe(({ client }) => {
        this._model = toClientTransformer.transform(client);
      });
  };

  public gotoSustainabilityReporting = () => {
    this.saveDirtyBeforeClose(false);
    this.router.navigateByUrl('/sustainability');
  };

  // openGenerateAdvisoryReport() {
  //   openDialog(this.dialogService, GenerateAdvisoryReportDialog, {
  //     client: toClientTypeTransformer.transform(this._model),
  //   });
  // }

  private showWarningForChangingResponsibleUser() {
    openTranslatableDialog({
      deps: { dialogService: this.dialogService, translationService: this.translationService, store: this.store },
      componentType: ChangeResponsibleWarningDialog,
      data: {},
    });
  }

  private onPreClientSave() {
    this.hidePleaseWait = false;
    this.setType();
    this.setDashedCorporateIdentity();
    if (this._model.id === -1) {
      this._model.id = null;
    }
    if (this._model.userId === 0) {
      this._model.userId = null;
    }
  }

  private onAfterClientSave(client: Client, message: string) {
    if (this.isNewClient || this.hasTeamsChanged(client)) {
      this.store.dispatch(TeamsActions.loadAllTeams()); // need to reload teams so the edit team page include changes to this client
    }
    this._model = client;
    this.handleReturnEvent(client);
    this.store.dispatch(ToastActions.showInfoMessage({ summary: this.i18n.saved, detail: message }));
    this.isDirty(new DirtyItem('BasicDetails', false));
    this.isDirty(new DirtyItem('BusinessDetails', false));
    this.userAuthFacade.updateAccessRightBasedOnResponsibleUserId(this._model.userId);
    this.hidePleaseWait = true;
    this.store.dispatch(ClientActions.loadAllClients());
    this.config.data.updateEmitter?.(true);
    this.updateTeams(client, this.rootTeam.id);
  }

  private setDashedCorporateIdentity() {
    if (!this._model?.corporateIdentity) {
      return;
    }

    if (this._model.corporateIdentity.length !== 10 || !isValidCorporateIdentity(this._model.corporateIdentity)) {
      return;
    }

    const dashPosition = 6;
    const years = this._model.corporateIdentity.slice(0, dashPosition);
    const checkSum = this._model.corporateIdentity.slice(dashPosition);
    this._model.corporateIdentity = `${years}-${checkSum}`;
  }

  private updateTeams = (client: Client, rootTeamId: number) => {
    // need to delay the update to avoid ExpressionChangedAfterItHasBeenCheckedError
    setTimeout(() => {
      this.teams = client?.teams?.filter((t) => t.id !== rootTeamId);
      this.selectedTeamIds = client?.teams?.map((t) => t.id);
    }, 0);
  };

  private hasTeamsChanged = (client: Client) => {
    const clientIds = client?.teams?.map((t) => t.id) ?? [];
    const modelIds = this._model?.teams?.map((t) => t.id) ?? [];

    return clientIds.length !== modelIds.length || !clientIds.every((id) => modelIds.includes(id));
  };

  private reactToCreditInformationUpdate = () => {
    this.store
      .select(CreditInformationSelectors.selectCreditInformation)
      .pipe(
        filter((creditInformation) => Boolean(creditInformation)),
        this.takeUntilDestroyed(),
      )
      .subscribe((creditInformation) => {
        if (this.isNewClient) {
          this.applyCreditInformationToModel(creditInformation);
          return;
        }

        this.showCreditInformationToUpdateDialog(creditInformation);
      });
  };

  private applyCreditInformationToModel(creditInformation: CreditInformationType | KvkInformationType): void {
    if (isKvkInformationType(creditInformation)) {
      this._model = Object.assign(this._model, toClientTypeFromKvkInformationTransformer.transform(creditInformation));
      return;
    }

    this._model = Object.assign(this._model, toClientTypeFromCreditInformationTransformer.transform(creditInformation));

    if (this._model.type && this._model.type.name) {
      this.selectedType = this._model.type.name; // update type-select element
    }

    // get default accounting period
    const accountPeriod = getAccountPeriod(creditInformation);
    if (!accountPeriod) {
      return;
    }

    this.creditInformationDefaultFinancialYears = new FinancialYear();
    this.creditInformationDefaultFinancialYears.span = accountPeriod;
  }

  private showCorporateIdentityExistsDialog() {
    return openTranslatableDialog({
      deps: { dialogService: this.dialogService, translationService: this.translationService, store: this.store },
      componentType: CorporateIdentityExistsDialog,
      data: {},
    }).pipe(
      mergeMap((result) => {
        if (!result?.confirmed) {
          return EMPTY;
        }

        this.onPreClientSave();

        return this.clientService.addClient(this._model, this.teamIds).pipe(take(1));
      }),
    );
  }

  private getFirmCountryCodeObservable() {
    return this.store.select(FirmSelectors.selectCountryCode);
  }

  private createCloudDbButtonTextObservable() {
    return this.getFirmCountryCodeObservable().pipe(
      map((countryCode) => {
        if (!this.allInclusiveService.isLoggedInWithBLTAService) {
          return this.i18n.createNewCompanyDatabase;
        }

        if (isSweden(countryCode)) {
          return this.i18n.createCollaborationPackageInBlappAndBLA;
        }
        return this.i18n.createCollaborationPackageInBlapp;
      }),
    );
  }

  // eslint-disable-next-line max-lines-per-function
  private getTranslations(): NewClientDialogTranslations {
    return {
      archived: this.translate('archived'),
      newClient: this.translate('newClient'),
      basicInformation: this.translate('basicInformation'),
      customerNumber: this.translate('customerNumber'),
      responsibleUser: this.translate('responsibleUser'),
      companyType: this.translate('companyType'),
      name: this.translate('name'),
      phone: this.translate('phone'),
      mobile: this.translate('mobile'),
      address: this.translate('address'),
      zipCode: this.translate('zipCode'),
      city: this.translate('city'),
      email: this.translate('email'),
      country: this.translate('country'),
      webpage: this.translate('webpage'),
      residence: this.translate('residence'),
      signatory: this.translate('signatory'),
      // advisoryReport: this.translate('advisoryReport'),
      // activateAdvisoryTool: this.translate('activateAdvisoryTool'),
      openSusainabilityReporting: this.translate('openSusainabilityReporting'),
      activateSustainabilityReporting: this.translate('activateSustainabilityReporting'),
      saveAndUpdateCloudCompany: this.translate('saveAndUpdateCloudCompany'),
      saveAndUpdate: this.translate('saveAndUpdate'),
      saveOnlyInFirmSupport: this.translate('saveOnlyInFirmSupport'),
      businessDetails: this.translate('businessDetails'),
      financialYears: this.translate('financialYears'),
      assignments: this.translate('assignments'),
      contacts: this.translate('contacts'),
      documents: this.translate('documents'),
      notes: this.translate('notes'),
      cloudServices: this.translate('cloudServices'),
      lundify: this.translate('lundify'),
      aml: this.translate('aml'),
      responsibleUserDisabledTooltipMessage: this.translate('responsibleUserDisabledTooltipMessage'),
      newCollaborationPackage: this.translate('newCollaborationPackage'),
      newCollaborationPackageDescriptionText: this.translate('newCollaborationPackageDescriptionText'),
      clientHasBeenSaved: this.translate('clientHasBeenSaved'),
      clientHasBeenSavedAndUpdatedInCloud: this.translate('clientHasBeenSavedAndUpdatedInCloud'),
      saved: this.translate('saved'),
      createNewCompanyDatabase: this.translate('createNewCompanyDatabase'),
      createCollaborationPackageInBlappAndBLA: this.translate('createCollaborationPackageInBlappAndBLA'),
      createCollaborationPackageInBlapp: this.translate('createCollaborationPackageInBlapp'),
      subscription: this.translate('subscription'),
      subscriptionTabTooltipNoPublicKey: this.translate('subscriptionTabTooltipNoPublicKey'),
      subscriptionTabTooltipPersonType: this.translate('subscriptionTabTooltipPersonType'),
      subscriptionTabTooltipNoAdminRights: this.translate('subscriptionTabTooltipNoAdminRights'),
      subscriptionTabTooltipOnlyWorkflowFirm: this.translate('subscriptionTabTooltipOnlyWorkflowFirm'),
    };
  }
}
